module.exports = __webpack_public_path__ + "img/magazine05.fd6eac00.jpg";